/* src/app/pages/user/auth-log/auth-log.component.scss */
table {
  width: 100%;
}
/*# sourceMappingURL=auth-log.component.css.map */
